<b-table [items]="policyMonitoringVersions" [selection]="false" [editable]="false" [archetypeEntries]="policyMonitoringTypes">
  <column labelKey="policy.monitoring.type" property="policyMonitoring.type" dictionary="RatingType" type="archetype" [link]="true" (linkClick)="toPolicyMonitoringVersion($event)"></column>
  <column property="resultType" labelKey="common.result" dictionary="PolicyMonitoringType"></column>
  <column property="creationDate"  labelKey="common.creationDate" type="date"></column>
  <column property="nextReviewDate"  labelKey="common.nextReviewDate" type="date"></column>
</b-table>

